import React from 'react';
import SetupAccountsStep from 'components/AccountConnectionFlow/SetupAccountsStep';

const SetUpBingAdsAccountsStep = () => {
  return <SetupAccountsStep />;
};

export default SetUpBingAdsAccountsStep;
